export default __webpack_public_path__ + "static/AUTO-1cb3559b5965fad7968c1cb9d82af71a.jpg";